import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent",
  "aria-hidden": "true"
}

const BASE =
  'inline-flex h-[38px] flex-shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border px-4 text-sm transition-colors focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 disabled:cursor-not-allowed'


export default {
  __name: 'WizardButton',
  props: {
  variant: { type: String, default: 'secondary' },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  to: { type: [String, Object], default: null }
},
  emits: ['click'],
  setup(__props) {

const VARIANTS = {
  primary:
    'border-gray-800 bg-gray-800 font-semibold text-white hover:bg-gray-900 disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-500',
  secondary:
    'border-gray-300 bg-white font-medium text-gray-900 hover:border-gray-400 hover:bg-gray-50 disabled:text-gray-400 disabled:hover:bg-white',
  danger: 'border-red-200 bg-red-50 font-medium text-red-700 hover:border-red-300 hover:bg-red-100 disabled:opacity-50'
}




return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (__props.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.to,
        class: _normalizeClass([BASE, VARIANTS[__props.variant]])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: _normalizeClass([BASE, VARIANTS[__props.variant]]),
        disabled: __props.disabled || __props.loading,
        "aria-busy": __props.loading || undefined,
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
      }, [
        (__props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
}
}

}